<template>
  <div id="lead-title">
    <div class="lead-title-container">
      <div class="grid-column ai-c jc-s">
        <div class="alert-img">
          <img
            alt="img-size-24"
            :src="getLeadImage(alertInfo.alertGroup)"
            class="img-size-24"
          >
        </div>
        <div class="sac__font-24 f-white semi-bold">
          {{ alertInfo.title }}
        </div>
      </div>
      <div class="grid-column ai-s jc-s gap-10">
        <div
          v-if="showDismiss"
          class="lead-option margin-right-8"
        >
          <button
            class="action-img"
            type="button"
            @click="handleDismiss(alert)"
          >
            <img
              alt="img-size-14"
              src="@shared/assets/img/service/dismiss.svg"
              class="img-size-20"
            >
            <span class="sac__font-10 f-white med">Dismiss</span>
          </button>
        </div>
        <div class="lead-option">
          <button
            v-if="!hideExport"
            class="export-button"
            type="button"
            @click="openLeadDetail(serviceInfo.alertNoticeId, alert)"
          >
            <span>Export</span>
            <img
              src="../../../assets/img/general/export-download.png"
              class="img-size-16"
              alt="Edit"
            >
          </button>
        </div>
      </div>
    </div>
    <div class="sac__font-12 f-white med margin-top-8">
      {{ alertInfo.description }}
    </div>
  </div>
</template>

<script>
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'LeadTitleInfo',
  mixins: [serviceMixin, unitPreferencesMixin],
  props: {
    alert: Object,
    hideDismiss: Boolean,
    hideExport: Boolean,
  },
  computed: {
    showDismiss() {
      return !this.hideDismiss && this.isSmacAdmin && this.alert.alertId !== this.serviceInfo.topAlertId;
    },
    alertInfo() {
      const {
        alertGroup,
        severity,
        title,
        description,
      } = this.alert;

      return {
        alertGroup,
        severity,
        title,
        description: this.replaceFahrenheitWithCelsius(description),
      };
    },
  },
  methods: {
    getLeadImage(type) {
      return require(`@shared/assets/img/leads/${type}.png`);
    },
    handleDismiss(alert) {
      this.$store.dispatch('changeServiceValues', [{
        field: 'selectedAlert',
        value: alert,
      }, {
        field: 'showActionModal',
        value: true,
      }, {
        field: 'actionModalView',
        value: 'dismiss-alert',
      }]);
    },
    openLeadDetail(leadId, alert) {
      const { category } = alert;
      if (category === 'Performance' || category === 'Leak') {
        window.open(`/lead/pdf/${leadId}`);
      } else {
        this.toggleActionModal(true, 'coming', leadId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#lead-title {
  width: 100%;
  .alert-img {
    height: 2rem;
    width: 2rem;
    display: grid;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-right: 10px;
    background-color: $E4;
  }
  .lead-title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .action-img {
    display: grid;
    align-items: center;
    justify-items: center;
  }
  .export-button {
    height: 38px;
    padding: 0 8px;
    color: $WHITE;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.875rem;
    font-weight: 700;
    border: 1px solid $WHITE;
    border-radius: 6px;
  }
  .lead-option {
    position: relative;
    .tooltip-container {
      display: none;
      position: absolute;
      top: 50px;
      background-color: $NAVY100;
      z-index: 10;
      padding: 7px 16px 7px 16px;
      box-shadow: 0 3px 6px rgba(9, 15, 32, 0.07);
      border-radius: 6px;
      left: -100%;
      white-space: nowrap;
    }
    &:hover {
      .tooltip-container {
        display: block;
      }
    }
  }
}
</style>
